export default __webpack_public_path__ + "static/media/category-icon-AllCategories.8c3c3101.svg";